module.exports = __webpack_public_path__ + "static/kfc_vn_rollout-74842fe0462d569b9a6e5f1a20fb182f.jpg";